import { Action } from '@ngrx/store';

export enum ActionTypes {
    GET_USER_PERMISSIONS = '[Auth Guard] Get User Permissions',
    GET_USER_PERMISSIONS_SUCCESS = '[User Service] Get User Permissions Success',
    GET_USER_PERMISSIONS_FAILURE = '[User Service] Get User Permissions Failure',
}

export class GetUserPermissions implements Action {
    readonly type = ActionTypes.GET_USER_PERMISSIONS;
}

export class GetUserPermissionsSuccess implements Action {
    readonly type = ActionTypes.GET_USER_PERMISSIONS_SUCCESS;

    constructor(
        public payload: {
            isTeamLead: boolean;
            isCAPStaff: boolean;
            isCommitteeMember: boolean;
        }
    ) {}
}

export class GetUserPermissionsFailure implements Action {
    readonly type = ActionTypes.GET_USER_PERMISSIONS_FAILURE;

    constructor(public payload: any) {}
}

export type Actions =
    | GetUserPermissions
    | GetUserPermissionsSuccess
    | GetUserPermissionsFailure;
